var runtime = {
  currentUser: null,
  configuration: {
    commentsWidget: {
      validSupplierCommentKeys: ['externalComment', 'description']
    },
    partners: [1,2,3,4]
  },
  isPartner: function() {
    return _.contains(this.currentUser.get('partner'), this.configuration.partners);
  }
};

window.runtime = runtime;
export {runtime};
